import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';

import { Creators as GroupsActions, Types as GroupsTypes } from 'store/ducks/groups';

function* getGroupRequest(action) {
  try {
    const { id } = action.payload;
    const url = `auth/v2/groups/${id}`;
    const response = yield call(api.get, url);

    yield put(GroupsActions.getGroupSuccess(response.data));
  } catch (error) {
    yield put(GroupsActions.getGroupFailure());
  }
}

function* getGroupsRequest(action) {
  try {
    const { page } = action.payload;
    const url = `auth/v2/groups?page=${page}&per=25`;
    const response = yield call(api.get, url);

    yield put(GroupsActions.getGroupsSuccess(response.data));
  } catch (error) {
    yield put(GroupsActions.getGroupsFailure());
  }
}

function* createGroupRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'auth/v2/groups';
    yield call(api.post, url, data);

    yield put(push('/configs/groups'));
    yield call(swal, 'Adicionado', 'Novo grupo adicionado', 'success');
    yield put(GroupsActions.createGroupSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível criar o grupo.', 'error');
    yield put(GroupsActions.createGroupFailure());
  }
}

function* updateGroupRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `auth/v2/groups/${id}`;
    yield call(api.put, url, data);

    yield put(push('/configs/groups'));
    yield call(swal, 'Atualizado', 'Grupo atualizado', 'success');
    yield put(GroupsActions.updateGroupSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar o grupo.', 'error');
    yield put(GroupsActions.updateGroupFailure());
  }
}

function* getGroupsRolesRequest(action) {
  try {
    const { query } = action.payload;
    const url = `auth/v2/roles?search=${query}&per=20`;
    const response = yield call(api.get, url);

    yield put(GroupsActions.getGroupsRolesSuccess(response.data));
  } catch (error) {
    yield put(GroupsActions.getGroupsRolesFailure());
  }
}

export default function* sagaGroups() {
  yield takeLatest(GroupsTypes.GET_REQUEST, getGroupRequest);
  yield takeLatest(GroupsTypes.GET_LIST_REQUEST, getGroupsRequest);
  yield takeLatest(GroupsTypes.CREATE_REQUEST, createGroupRequest);
  yield takeLatest(GroupsTypes.UPDATE_REQUEST, updateGroupRequest);
  yield takeLatest(GroupsTypes.GET_ROLES_REQUEST, getGroupsRolesRequest);
}
